import { Grid } from "@material-ui/core";

import { InstalledAssets } from "./InstalledAssets";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { InstalledAssetsRecommendations } from "./InstalledAssetsRecommendations";

export const InstalledAssetsWithRecommendations = () => {
  return (
    <ShaDowBox fullHeight>
      <Grid container>
        <Grid item sm={8}>
          <InstalledAssets />
        </Grid>
        <Grid item sm={4}>
          <InstalledAssetsRecommendations />
        </Grid>
      </Grid>
    </ShaDowBox>
  );
};
